module.exports = __webpack_public_path__ + "37e0fb2204fcecea5ccb2f2ffcffd06f.png";